<template>
<div>
  <div class="leftformitem leftformitem2" v-if="property.radio==1">
    <div class="leftformtitle">
      <span>{{property.name1}}</span>
      <span v-if="property.checked" class="ischeck">*</span>
    </div>
    <div class="leftformbd">
      <div class="leftforminput">
         <div class="formradio">
           <div class="item1" v-for="(item,index) in property.list2" :key="index">
            <span class="radioicon"></span>
            <span class="radiotxt">{{item.label}}</span>
            </div>
         </div>
         
      </div>
    </div>
  </div>
  <div class="formsinglecheck " v-if="property.radio==2">
    <div class="checktitle"> <span >{{property.name2}}</span><span v-if="property.checked" class="ischeck">*</span></div>
    <div class="formcheckbox formcheckbox2">
      <div class="item" v-for="(item,index) in property.list" :key="index">
        <span class="radioicon2 radioicon3"></span>
        <span class="radiotxt">{{item.label}}</span>
      </div>
    </div>
  </div>
         </div>
</template>
<script>
export default {
  props: ["property"],
  data() {
    return {
       form: {}
    };
  }
};
</script>

 